import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { DotsSixVerticalIcon } from "@phosphor-icons/react";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { useTranslation } from "react-i18next";

type TProps = {
  id: number;
  disabled: boolean;
  children: React.ReactNode;
};

export function SortableDimensionRow({ id, disabled, children }: TProps) {
  const { t } = useTranslation("projects");
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
    disabled,
    animateLayoutChanges: () => false
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 10 : "auto"
  };

  return (
    <div ref={setNodeRef} style={style} className="flex items-center gap-1">
      <button
        type="button"
        className={cn(
          "flex h-4 w-4 shrink-0 items-center justify-center text-[#a1a1aa]",
          disabled ? "cursor-not-allowed" : "cursor-grab active:cursor-grabbing"
        )}
        aria-label={t("dimensions.dragToReorder")}
        {...attributes}
        {...listeners}
      >
        <DotsSixVerticalIcon size={16} weight="bold" />
      </button>
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
